import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {RightBarController} from './RightBarController';
import {DashboardState} from '../../states/dashboard/_contracts/DashboardState';
import {SearchTags} from './search-tags/SearchTags';
import {LibrarySection} from './sections/library-section/LibrarySection';
import {MessagesSection} from './sections/messages-section/MessagesSection';
import {WifiScanHistorySection} from './sections/wifi-scan-history-section/WifiScanHistorySection';
import {VisualScanHistorySection} from './sections/visual-scan-history-section/VisualScanHistorySection';
import {
    ResourceGallerySection,
    IResourceGallerySectionProps,
    IResourceGallerySectionEvents
} from './sections/resource-gallery-section/ResourceGallerySection';
import {LibraryDialog} from './sections/library-section/library-dialog/LibraryDialog.component';
import './RightBar.scss';

interface RightBarProps {
    rightBarController: RightBarController;
    dashboardState: DashboardState;
}

@observer
export class RightBar extends TechseeBaseComponent<RightBarProps> {
    private getResourceGalleryProps(ctrl: any): IResourceGallerySectionProps {
        const {rightBarController, dashboardState} = this.props;
        const rightBarState = dashboardState.rightBarState;
        const eventEmitter: IResourceGallerySectionEvents = {
            emit: (event: any, ...args: any[]) => {
                (rightBarController as any).emit(event, ...args);
            }
        };
        return {
            ctrl,
            eventEmitter,
            flattenedHistoryRecords: rightBarState.flattenedHistoryRecords,
            screenshots: dashboardState.screenshots || [],
            multipleImagesSharingEnabled: dashboardState.multipleImagesSharingEnabled || false,
            isHighImageSharingQuality: dashboardState.isHighImageSharingQuality || false,
            enableSharingImagesContainer: dashboardState.enableSharingImagesContainer || false,
            resourcesReadyToBeShared: rightBarState.resourcesReadyToBeShared,
            enableCopyToClipboard: dashboardState.enableCopyToClipboard || false,
            enableEmailImageSharing: dashboardState.enableEmailImageSharing || false,
            sharingModeActions: rightBarState.sharingModeActions,
            dateFormat: rightBarState.dateFormat,
            areAllResourcesSelected: rightBarController.areAllResourcesSelected.bind(rightBarController),
            downloadAndEmailSharing: () => rightBarController.downloadAndEmailSharing,
            enableLocalImageSaving: dashboardState.enableLocalImageSaving || false,
            isActiveResource: rightBarController.isActiveResource.bind(rightBarController),
            imagesPreviewHeight: rightBarController.imagesPreviewHeight.bind(rightBarController),
            imagesPreviewWidth: rightBarController.imagesPreviewWidth.bind(rightBarController),
            getImageLayout: rightBarController.getImageLayout.bind(rightBarController),
            isQuickShareEnabled: () => rightBarController.isQuickShareEnabled,
            isSelectResourceReady: rightBarController.isSelectResourceReady.bind(rightBarController),
            isResourceSelected: rightBarController.isResourceSelected.bind(rightBarController),
            uploadLocalImage: rightBarController.uploadLocalImage.bind(rightBarController),
            failedLocalLoad: rightBarController.failedLocalLoad.bind(rightBarController)
        };
    }

    renderInternal(): JSX.Element {
        const {rightBarController, dashboardState} = this.props;
        const expandRightBar = rightBarController.expandRightBar;

        return (
            <div className={`dashboard-right-sidebar-container ${expandRightBar ? 'expanded' : ''}`}>
                <SearchTags ctrl={rightBarController.searchTagsController} />

                <div className='dashboard-sidebar-accordion-container'>
                    <div
                        className={`main-text-color sidebar-accordion ${rightBarController.libraryTaggingMode ? 'library-open' : ''}`}>
                        <ResourceGallerySection
                            {...this.getResourceGalleryProps(rightBarController.imagesGalleryController)}
                        />

                        <LibrarySection ctrl={rightBarController.librarySectionController} />

                        <MessagesSection ctrl={rightBarController.messagesSectionController} />

                        <WifiScanHistorySection ctrl={rightBarController.wifiScanHistoryController} />

                        <VisualScanHistorySection ctrl={rightBarController.visualScanHistoryController} />

                        <ResourceGallerySection
                            {...this.getResourceGalleryProps(rightBarController.historyGalleryController)}
                        />
                    </div>
                </div>

                <LibraryDialog ctrl={rightBarController.libraryDialogController} />
            </div>
        );
    }
}
